import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('magnetic-btn-component', {

    data() {
        return {

        };
    },

    mounted() {
        if (document.querySelector('html').classList.contains('touchevents') || window.matchMedia('(max-width: 1024px)').matches) {
            return;
        }

        this.btnArea = this.$el.querySelector('.magnetic-btn');

        this.btnArea.addEventListener('mousemove', (e) => {
            this.callParallax(e);
        });

        this.btnArea.addEventListener('mouseleave', (e) => {
            gsap.to('.magnetic-btn', {
                x: 0,
                y: 0,
                ease: 'power4.out',
                duration: 1.4,
            });
        });
    },

    methods: {
        callParallax(e) {
            this.calculateBtnPosition(e, '.magnetic-btn');
        },

        calculateBtnPosition(e, target, movement = 1) {
            const boundingRect = this.btnArea.getBoundingClientRect();
            const relX = e.pageX - boundingRect.left;
            const relY = e.pageY - boundingRect.top;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            gsap.to(target, {
                x: (relX - boundingRect.width / 2) * movement,
                y: (relY - boundingRect.height / 2 - scrollTop) * movement,
                ease: 'power4.out',
                duration: 1.2,
            });
        },
    },
});
